import { render } from "./IndexButton.vue?vue&type=template&id=39efb92a&scoped=true"
import script from "./IndexButton.vue?vue&type=script&lang=js"
export * from "./IndexButton.vue?vue&type=script&lang=js"

import "./IndexButton.vue?vue&type=style&index=0&id=39efb92a&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39efb92a"]])

export default __exports__